import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Broker } from '@c4/core';

import { Item } from '../interfaces/item.interface';
import { ProgrammingUtilsService as Utils } from './utils.service';

declare var _: any;

export interface ItemsState {
  itemsList: Item[];
  itemsMap: Map<number, Item>;
  ready: boolean
}

const INITIAL_STATE: ItemsState = {
  itemsList: [],
  itemsMap: new Map<number, Item>(),
  ready: false
};

const STORE_NAME: string = 'PROGRAMMING:ITEMS:';
const SET_ITEMS: string = STORE_NAME + 'SET_ITEMS';

export function itemsReducer(state: ItemsState = INITIAL_STATE, { type, payload }): ItemsState {

  switch (type) {
    case SET_ITEMS:
      return Object.assign({}, state, { itemsList: payload.itemsList, itemsMap: payload.itemsMap, ready: true });
  }

  return state;
};

@Injectable()
export class ItemsService {

  ready: Observable<boolean>;
  itemsList: Observable<Item[]>;

  private _itemsMap: Observable<Map<number, Item>>;

  constructor(
    private store: Store<any>,
    private broker: Broker
  ) {
    this.broker.getObservable<Item[]>({
      path: '/api/v1/items'
    }).subscribe(items => {
      this.handleUpdates(items);
    });

    this.ready = this.store.select(s => s.programmingItems.ready);
    this._itemsMap = this.store.select(s => s.programmingItems.itemsMap);
    this.itemsList = this.store.select(s => s.programmingItems.itemsList);
  }

  getItem(id: number): any {
    let itemsMap: Map<number, Item> = Utils.snapshot<Map<number, Item>>(this._itemsMap);
    return itemsMap.get(id);
  }

  getRoom(roomId: number): any {
    let items: Item[] = Utils.snapshot<Item[]>(this.itemsList);
    return items.filter(item => item.id === roomId && item.type === 8)[0];
  }

  // getAgent
  // getLocation
  // get...

  private handleUpdates(updates: Array<any>) {

    let itemsMap: Map<number, Item> = Utils.snapshot(this._itemsMap);

    // NOTE items updates are incremental so we have to add or update the existing list
    // easiest to do this by maintaining a map by id
    if (updates) {
      updates.forEach(item => {
        // console.log('items: handling update item', item);
        if (item.compareStatus) {
          // console.log('items: checking compare status', item.compareStatus);
          switch (item.compareStatus) {
            case 'removed':
              let deleted = itemsMap.delete(item.id);
              // console.log('items: deleted item', item, deleted, itemsMap);
              break;
            case 'changed':
            case 'added':
              itemsMap.set(item.id, item);
              // console.log('items: added incremental item', item, itemsMap);
              break;
            default: console.warn('unrecognized compare status on item update', item);
          }
        } else {
          // NOTE assume this is a first fetch, everything is new
          itemsMap.set(item.id, item);
          // console.log('items: initial update, added new item', item);
        }
      });
    }

    let itemsList = Array.from(itemsMap.values());

    let payload = { itemsList: itemsList, itemsMap: itemsMap };

    this.store.dispatch({ type: SET_ITEMS, payload: payload });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/services/items.service.ts